import { render, staticRenderFns } from "./ParametrizacaoAcaoPasso7.vue?vue&type=template&id=ec5faaac&lang=html"
import script from "./ParametrizacaoAcaoPasso7.vue?vue&type=script&lang=js"
export * from "./ParametrizacaoAcaoPasso7.vue?vue&type=script&lang=js"
import style0 from "./ParametrizacaoAcaoPasso7.vue?vue&type=style&index=0&id=ec5faaac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports